import { Col, Row } from "antd";
import { ColProps, RowProps } from "./type";

function AntRow(props: RowProps) {
  return <Row {...props} />;
}
function AntCol(props: ColProps) {
  return <Col {...props} />;
}

export { AntRow as Row, AntCol as Col };
